module.exports = __webpack_public_path__ + "img/boltjanskiy.d520f9ae.jpg";